<div class="bg" (click)="close()"></div>
<div class="close" (click)="close()"><ui-icon [nameIcon]="'close'"></ui-icon></div>
<div class="custom-modal">
  <div class="arrow arrow-prev" *ngIf="images.length > 1" (click)="prevImage()">
    <ui-icon nameIcon="arrow_back"></ui-icon>
  </div>
  <div class="gallery-image">
    <div class="gallery-image__list">
      <div class="gallery-image__item">
        <img [src]="images[currentImageIndex].imageUrl"
             [alt]="images[currentImageIndex].name"
             class="image">
      </div>
    </div>
  </div>
  <div class="arrow arrow-next"  *ngIf="images.length > 1" (click)="nextImage()">
    <ui-icon nameIcon="arrow_forward"></ui-icon>
  </div>
</div>
